// extracted by mini-css-extract-plugin
export default {"animate-pattern":"Solutions_animate-pattern__NYUgA","patternFloat":"Solutions_patternFloat__tc2oV"};